import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from '@react-google-maps/api';
import { markerIcons } from '../../app/google_maps';
import DrawingManager from '../drawing_manager';

function onDragEnd({ latLng }) {
  $('#school_address_attributes_lat').val(latLng.lat());
  $('#school_address_attributes_lng').val(latLng.lng());
  $('#school_coordinates').val(`${latLng.lat()}, ${latLng.lng()}`);

  const $form = $('#school_address_attributes_lat').parents('form');
  if ($form.data('auto-submit')) { $form.submit(); }
}

export default class SchoolMarker extends Component {
  constructor(props) {
    super(props);
    this.state = { hover: false };
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.selected) { return this.unsubscribeUIEvents(); }
    return this.subscribeUIEvents();
  }

  componentWillUnmount() {
    this.unsubscribeUIEvents();
  }

  onMouseOver() {
    this.setState({ hover: true });
  }

  onMouseOut() {
    this.setState({ hover: false });
  }

  unsubscribeUIEvents() {
    $('#school_radius').off(this.eventName('change'));
  }

  subscribeUIEvents() {
    $('#school_radius').off(this.eventName('change')).on(this.eventName('change'), ({ currentTarget }) => {
      const $form = $(currentTarget).parents('form');
      if ($form.data('auto-submit')) { $form.submit(); }
    });
  }

  eventName(event) {
    return `${event}.school${this.props.school.id}`;
  }

  render() {
    const { school, selected, onClick } = this.props;
    let infoWindow;
    if (this.state.hover) {
      infoWindow = (
        <InfoWindow onCloseClick={this.onMouseOut}>
          <div className="info-school-name">{school.name}</div>
        </InfoWindow>
      );
    }
    return (
      <div>
        <Marker
          key={school.id}
          position={{ lat: school.lat, lng: school.lng }}
          icon={markerIcons.school}
          clickable
          draggable={selected}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onClick={() => { onClick(school); }}
          onDragEnd={onDragEnd}
        >
          {infoWindow}
        </Marker>
        <DrawingManager
          selected={selected}
          idPrefix="school"
          object={school}
        />
      </div>);
  }
}

SchoolMarker.propTypes = {
  school: PropTypes.shape({
    id: PropTypes.number,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
